import './Footer.css';
import { Col, Container, Row } from 'react-bootstrap';

const Footer = () => {
  return (
    <Container fluid className="footer">
      <Row className="footer_row">
        <Col className="footer_col mt-4">
          <h6 className="heading-footer">
            <b className="company_name">
              Nilganga Hydropower Company Ltd.
            </b>
          </h6>
        </Col>
      </Row>

      <Row
        className="px-4 mx-4"
        style={{ textAlign: "center", marginTop: "30px" }}
      >
        <Col>
          <p className="project_site">
            <b>PROJECT SITE : </b>
            KHARCHE, NASON RURAL MUNICIPALITY, MANANG, NEPAL
          </p>
        </Col>

        <Col>
          <p className="head_office">
            <b className="head_inner">HEAD OFFICE : </b>
            KATHMANDU-32, TINKUNE
          </p>

          <p className="address_info">
            TEL : 977-1-4111853 MOBILE NO : 9856030674
          </p>

          <p className="address_info">
            <span className="inner_email">
              E-MAIL: nilgangahydropower@gmail.com
            </span>
          </p>
        </Col>

        <Col className="contact_office22">
          <b className="office_number">CONTACT OFFICE : </b>
          <span className="contact_rupendehi">
            TILOTTAMA-3, RUPANDEHI
          </span>
          <br />

          <p className="address_info">
            <span className="first_number">
              MOBILE NO : 9857035971
            </span>
            <br />
            <span className="second_number">
              9857037971
            </span>
          </p>
        </Col>
      </Row>

      {/* Social Media */}

      <Row style={{ marginTop: "10px" }}>
        <Col className="column_footer" style={{ textAlign: "center" }}>
          <p className="paragraph_icon">
            <a
              className="facebook"
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>

            <a
              className="twitter"
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-x-twitter"></i>
            </a>

            <a
              className="instagram"
              href="https://instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-instagram"></i>
            </a>
          </p>
        </Col>
      </Row>

      {/* Copyright */}

      <Row className="second_footer_row">
        <Col className="second_footer_column" xs={6}>
          <p
            className="paragraph-copyright"
            style={{ marginRight: "30px" }}
          >
            <b>
              Copyright{" "}
              <i
                className="fa-regular fa-copyright"
                style={{
                  color: "white",
                  fontSize: "12px",
                  marginTop: "18px",
                }}
              ></i>{" "}
              2025 Nilganga Hydropower Company
            </b>
          </p>
        </Col>

        <Col>
          <p
            className="paragraph-copyright"
            style={{ marginTop: "14px" }}
          >
            <span className="footer_powered">
              Developed by :{" "}
              <b>
                <u>
                  <a
                    href="https://tech.somarjun.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Somarjun Tech Company
                  </a>
                </u>
              </b>
            </span>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;